export default __webpack_public_path__ + "static/media/chartres7.e8c1b6bc.jpg";